import React, { Component } from 'react';
import '../App.css';
import {Alert, ToggleButtonGroup, Carousel, ToggleButton, Button, Well, Glyphicon, ProgressBar, Tabs, Tab, Panel, PanelGroup} from 'react-bootstrap';
import { StickyContainer, Sticky} from 'react-sticky';
import * as jsPDF from 'jspdf';
import header1 from'./OTK_header.png';
import header2 from'./OTK_header2.png';
import header3 from'./OTK_header3.png';
import header4 from'./OTK_header4.png';




class Appmain extends Component {
constructor(props) {
super(props);
this.state = {


};

}




render() {
return (
<div className="App">
<div>
    
<div>
<Carousel controls={false} indicators={false}>
  <Carousel.Item>
    <img width={1000} height={300} alt="1000x300" src={header1} />
  </Carousel.Item>
  <Carousel.Item>
    <img width={1000} height={300} alt="1000x300" src={header2} />
  </Carousel.Item>
  <Carousel.Item>
    <img width={1000} height={300} alt="1000x300" src={header3} />
  </Carousel.Item>
  <Carousel.Item>
    <img width={1000} height={300} alt="1000x300" src={header4} />
  </Carousel.Item>
</Carousel>
</div>    
    
    
<h1>Welcome to OrthoToolKit!</h1>
    


<p style={{textAlign: "left"}}>We provide the largest collection of easy-to-use orthopedic scores and calculators! We strive to constantly improve the user experience and to continually increase the number of available tools (the latest additions being the <a href="https://orthotoolkit.com/hoos-12/">Hip disability and Osteoarthritis Outcome Score 12</a>, the <a href="https://orthotoolkit.com/koos-12/">Knee injury and Osteoarthritis Outcome Score 12</a>, and the <a href="https://orthotoolkit.com/acl-rsi/">ACL Return to Sport after Injury survey</a>).</p>
    

    
<h3 style={{textAlign: "center"}}><a href="https://orthopowertools.com" target="_blank">OrthoPowerTools</a></h3>    
       
    
<p style={{textAlign: "left"}}>We recently built <a href="https://orthopowertools.com/" target="_blank">this</a> HIPAA compliant site to make collecting and analyzing patient reported outcomes <u>easier</u> and <u>more efficient</u> for you. Features include:</p>

<p style={{textAlign: "left"}}>1. A system that allows individuals to <b>remotely complete</b> patient reported outcome surveys and then <b>confidentially share</b> it with their clinician. Available scores include:</p>     
    
<p style={{textAlign: "left"}}><u>English Language</u>: <a href="https://orthopowertools.com/AOFASH" target="_blank">AOFAS Hallux </a>, <a href="https://orthopowertools.com/FAAM" target="_blank">FAAM</a>, <a href="https://orthopowertools.com/HOOS12" target="_blank">HOOS-12</a>, <a href="https://orthopowertools.com/KOOS12" target="_blank">KOOS-12</a>, <a href="https://orthopowertools.com/LEFS" target="_blank">LEFS</a>, <a href="https://orthopowertools.com/NDI" target="_blank">NDI</a>, <a href="https://orthopowertools.com/ODI" target="_blank">ODI</a>, <a href="https://orthopowertools.com/QUICKDASH" target="_blank">QuickDASH</a>, <a href="https://orthopowertools.com/SF12" target="_blank">SF-12</a>, <a href="https://orthopowertools.com/SF36" target="_blank">SF-36</a>, <a href="https://orthopowertools.com/SPADI" target="_blank">SPADI</a>, and <a href="https://orthopowertools.com/WHOQOLBREF" target="_blank">WHOQOL-BREF</a>.</p> 
    
<p style={{textAlign: "left"}}><u>Spanish Language (Saved With An English Translation)</u>: <a href="https://orthopowertools.com/LEFS-Spanish" target="_blank">Spanish LEFS (saved with an English translation)</a>, <a href="https://orthopowertools.com/NDI-Spanish" target="_blank">Spanish NDI (saved with an English translation)</a>, <a href="https://orthopowertools.com/QUICKDASH-Spanish" target="_blank">Spanish QuickDASH (saved with an English translation)</a>, and <a href="https://orthopowertools.com/SPADI-Spanish" target="_blank">Spanish SPADI (saved with an English translation)</a>.</p>     
    
<p style={{textAlign: "left"}}>2. Clinicians will automatically receive email alerts whenever a patient shares a score with them</p>

<p style={{textAlign: "left"}}>3. Clinicians can sign in <a href="https://orthopowertools.com/" target="_blank">here</a> to view and download <b>PDF reports</b> in order to assess their patients <b>progress</b> throughout their rehabilitation. They can also download a <b>CSV (excel) file</b> with all scores that have been shared with them for further analaysis. </p> 

<p style={{textAlign: "left"}}>4. Additionally, once signed in, clinicians can <b>send</b> their patients a <b>unique score request link</b>. </p> 

    
    
    
   
   
    
<h3 style={{textAlign: "left"}}>Browse our orthopedic scores and calculators:</h3>


<table style={{width:"100%"}}>
<tr>    
    <td style={{textAlign: "left"}}> <span><strong><u>Patient Reported Outcome Measures</u></strong></span> </td>
    <td style={{textAlign: "left"}}> <span><strong><u>Risk Assessments and Decision Aides</u></strong></span> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p>Upper Extremity:</p> </td>
    <td style={{textAlign: "left"}}> <p>General Health:</p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/quickdash/">Quick Disabilities of the Arm, Shoulder and Hand (QuickDASH)</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/charlson-comorbidity-index/">Charlson Comorbidity Index (CCI)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/dash/">Disabilities of the Arm, Shoulder and Hand (DASH)</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/elixhauser-comorbidity-index/">Elixhauser Comorbidity Measures (ECM)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/constant-shoulder/">Constant-Murley (Constant) Shoulder Score</a></p></td>
    <td style={{textAlign: "left"}}> <p>Neck and Back:</p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/penn-shoulder-score/">Penn Shoulder Score</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/ompsq-sf/">&Ouml;rebro Musculoskeletal Pain Screening Questionnaire - Short Form</a></p></td>
</tr>




<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/UCLA-shoulder/">UCLA Shoulder Rating</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/start-back/">STarT [Subgroups for Targeted Treatment] Back Screening Tool</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/wosi/">Western Ontario Shoulder Instability Index (WOSI)</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/tlics/">Thoracolumbar Injury Classification and Severity Score (TLICS)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/spadi/">Shoulder Pain and Disability Index (SPADI)</a></p></td>
    <td style={{textAlign: "left"}}> <p>Oncology:</p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/rowe/">Rowe Score for Shoulder Instability</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/mirels-criteria/">Mirels' Criteria</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/mayo-wrist/">Mayo Wrist Score</a></p></td>
    <td style={{textAlign: "left"}}> <p>DVT/PE:</p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/ases/">ASES Shoulder Index</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/caprini/">Caprini Score for Venous Thromboembolism</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/mayo-elbow/">Mayo Elbow Performance Score</a></p></td>
    <td style={{textAlign: "left"}}> <p>Pediatrics:</p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/simple-shoulder/">Simple Shoulder Test</a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/beighton-score/">Beighton Score</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/uefs/">Upper Extremity Function Scale (UEFS)</a></p></td> 
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/systemic-score/">Systemic Score for Marfans</a></p></td>            
</tr>

<tr>  
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/fast/">Functional Arm Scale for Throwers (FAST)</a></p></td>         
    <td style={{textAlign: "left"}}> <p>Concussion:</p> </td>        
</tr>


<tr> 
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/kjoc/">Kerlan-Jobe Orthopaedic Clinic (KJOC) Shoulder and Elbow Score</a></p></td>  
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/sac/">Standardized Assessment of Concussion</a></p> </td> 
</tr>

<tr>       
    <td style={{textAlign: "left"}}> <p>Hip:</p></td>          
    <td style={{textAlign: "left"}}> <p>Pain:</p></td> 
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/hagos/">Copenhagen Hip and Groin Outcome Score (HAGOS)</a></p></td>           
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/pseq/">Pain Self Efficacy Questionnaire (PSEQ)</a></p> </td> 
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/hoos/">Hip disability and Osteoarthritis Outcome Score (HOOS)</a></p></td>         
</tr>

<tr>         
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/hoos-12/">Hip disability and Osteoarthritis Outcome Score 12 (HOOS-12)</a></p></td>
</tr>

<tr>
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/hoos-jr/">Hip disability and Osteoarthritis Outcome Score for Joint Replacement (HOOS JR)</a></p></td>         
</tr>

<tr> 
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/harris-hip/">Harris Hip Score</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/hos/">Hip Outcome Score (HOS)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/lefs/">Lower Extremity Function Scale (LEFS)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p>Knee:</p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/koos/">Knee injury and Osteoarthritis Outcome Score (KOOS)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/koos_spanish/">Spanish Knee injury and Osteoarthritis Outcome Score (KOOS) with English translation</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/koos-12/">Knee injury and Osteoarthritis Outcome Score 12 (KOOS-12)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/koos-jr/">Knee injury and Osteoarthritis Outcome Score for Joint Replacement (KOOS JR)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/cincinnati/">Modified Cincinnati Rating System</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/knee-society-score/">Knee Society Score</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/kujala/">Kujala (Anterior Knee Pain Scale)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/marx/">Marx Activity Rating Scale</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/tegner-lysholm/">Tegner Lysholm Knee Scoring Scale</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/ikdc/">International Knee Documentation Committee (IKDC) Subjective Knee Evaluation</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/lefs/">Lower Extremity Function Scale (LEFS)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/kos/">Knee Outcome Survey (KOS)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/acl-rsi/">ACL Return to Sport after Injury (ACL-RSI) survey</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p>Foot and Ankle:</p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/faos/">Foot and Ankle Outcome Score (FAOS)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/faam/">Foot and Ankle Ability Measure (FAAM)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/fadi/">Foot and Ankle Disability Index (FADI)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/lefs/">Lower Extremity Function Scale (LEFS)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/ffi/">Foot Function Index (FFI)</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/aofas-ankle-hindfoot/">American Orthopaedic Foot and Ankle Society (AOFAS) ankle-hindfoot</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/aofas-midfoot/">American Orthopaedic Foot and Ankle Society (AOFAS) midfoot</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/aofas-mtp-ip/">American Orthopaedic Foot and Ankle Society (AOFAS) hallux</a></p></td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/aofas-mtp-ip-2/">American Orthopaedic Foot and Ankle Society (AOFAS) lesser toes</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/cait/">Cumberland Ankle Instability Tool (CAIT)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p>Neck and Back:</p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/ndi/">Neck Disability Index (NDI)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/oswestry/">Oswestry Disability Index (ODI)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/molbpdq/">Modified Oswestry Low Back Pain Disability Questionnaire (MOLBPDQ)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/roland-morris/">Roland-Morris Disability Questionnaire</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/srs-22/">Scoliosis Research Society 22 (SRS22r)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/comi-back/">Core Outcome Measures Index (COMI) Back</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p> General Health: </p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/sf-12/">12-Item Short Form Survey (SF-12)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/sf-20/">20-Item Short Form Survey (SF-20)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/sf-36/">36-Item Short Form Survey (SF-36)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/promis-10/">Patient-Reported Outcomes Measurement Information System (PROMIS Global-10)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/tampa-scale/">Tampa Scale of Kinesiophobia (TSK)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/tampa-scale-11/">Tampa Scale of Kinesiophobia - 11 (TSK-11)</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthotoolkit.com/vr-12/">Veterans RAND 12-Item Health Survey (VR-12)</a></p>   </td>
</tr>


</table>



</div>
</div>
);
}
}
export default Appmain;

    
//<p style={{textAlign: "left"}}>We recently completed a site-wide upgrade. This improvement allows for:</p> 

//<p style={{textAlign: "left"}}>    
//<li>even faster loading times</li> 
//<li>increased site security</li> 
//<li>a more user-friendly format</li> 
//<li> additional calculator features (including a fixed header displaying the numeric score as well as more accessible, collapsible score descriptions at the top of the page)</li> 
//</p>    

//<p style={{textAlign: "left"}}>We also are continually adding new scores and calculators (most recently the <a href="https://orthotoolkit.com/sac/">Standardized Assessment of Concussion</a>).</p>     
    
//<p style={{textAlign: "left"}}>We hope that the updated site and new surveys improve your experience! Please <a href="https://orthotoolkit.com/contact-us/">contact us</a> with any issues or comments and do check back soon as we are implementing more features and are integrating more tools.</p>   

/*
<table style={{width:"100%"}}>
    
<tr>         
    <td style={{textAlign: "left"}}> <p><u>English Language Tools</u></p>  </td>        
    <td style={{textAlign: "left"}}></td>
</tr>
    
<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/AOFASH" target="_blank">AOFAS Hallux </a></p></td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/FAAM" target="_blank">FAAM</a></p> </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/HOOS12" target="_blank">HOOS-12</a></p> </td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/KOOS12" target="_blank">KOOS-12</a></p>  </td>
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/LEFS" target="_blank">LEFS</a></p> </td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/NDI" target="_blank">NDI</a></p>  </td>    
</tr>

<tr>  
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/ODI" target="_blank">ODI</a></p>  </td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/QUICKDASH" target="_blank">QuickDASH</a></p> </td>      
</tr>

<tr>  
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/SF12" target="_blank">SF-12</a></p> </td>      <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/SF36" target="_blank">SF-36</a></p> </td>     
</tr>

<tr>     
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/SPADI" target="_blank">SPADI</a></p>  </td>  
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/WHOQOLBREF" target="_blank">WHOQOL-BREF</a></p> </td>    
</tr>

<tr>         
    <td style={{textAlign: "left"}}> <p><u>Spanish Language Tools (Saved With An English Translation)</u></p>  </td>        
    <td style={{textAlign: "left"}}></td>
</tr>


<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/LEFS-Spanish" target="_blank">Spanish LEFS (saved with an English translation)</a></p> </td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/NDI-Spanish" target="_blank">Spanish NDI (saved with an English translation)</a></p>  </td>     
</tr>

<tr>    
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/QUICKDASH-Spanish" target="_blank">Spanish QuickDASH (saved with an English translation)</a></p> </td>
    <td style={{textAlign: "left"}}> <p><a href="https://orthopowertools.com/SPADI-Spanish" target="_blank">Spanish SPADI (saved with an English translation)</a></p>  </td>     
</tr>


</table>

*/


// WEBPACK FOOTER //
// ./src/Components/Appmain.js